export default {
  headerHeight: 80,
};
